/**
 * Action modes used to configure the ProductLifecycleTimeline component.
 *
 * @remarks Corresponds to the ProductLifecycleActionMode enum in Billiant APIs.
 */
export enum ProductLifecycleActionMode {
  DEACTIVATE = "DEACTIVATE",
  RENEW = "RENEW",
}
